import type { DogProfile, GoalId, ProblemId } from './types';

export interface QuizOption<V extends string | number = string> {
  value: V;
  label: string;
  emoji?: string;
}

export const PROBLEM_OPTIONS: QuizOption<ProblemId>[] = [
  { value: 'pulling', label: 'Tire en laisse', emoji: '🦮' },
  { value: 'barking', label: 'Aboie trop', emoji: '🔊' },
  { value: 'biting', label: 'Mordille / mord', emoji: '🦷' },
  { value: 'jumping', label: 'Saute sur les gens', emoji: '🦘' },
  { value: 'potty', label: 'Pas encore propre', emoji: '💧' },
  { value: 'separation', label: 'Ne supporte pas la solitude', emoji: '🏠' },
  { value: 'recall', label: 'Ne revient pas au rappel', emoji: '📣' },
  { value: 'reactivity', label: 'Réagit aux chiens / passants', emoji: '⚡' },
  { value: 'chewing', label: 'Détruit des objets', emoji: '🧦' },
  { value: 'fear', label: 'Peureux (bruits, inconnus)', emoji: '😨' },
  { value: 'guarding', label: 'Protège sa gamelle / ses jouets', emoji: '🦴' },
  { value: 'hyperactivity', label: 'Trop excité, jamais calme', emoji: '🌪️' },
  { value: 'digging', label: 'Creuse', emoji: '🕳️' },
  { value: 'counter_surfing', label: 'Vole sur la table', emoji: '🍗' },
  { value: 'car', label: 'Mal à l’aise en voiture', emoji: '🚗' },
];

export const GOAL_OPTIONS: QuizOption<GoalId>[] = [
  { value: 'obedience', label: 'Un chien obéissant', emoji: '🎓' },
  { value: 'problems', label: 'Régler des problèmes de comportement', emoji: '🛠️' },
  { value: 'bond', label: 'Renforcer notre complicité', emoji: '❤️' },
  { value: 'calm', label: 'Un chien plus calme', emoji: '🧘' },
  { value: 'socialization', label: 'Un chien sociable et confiant', emoji: '🤝' },
  { value: 'tricks', label: 'Apprendre des tours', emoji: '🎩' },
  { value: 'sport', label: 'Faire du sport ensemble', emoji: '🏃' },
];

export const DEFAULT_PROFILE: DogProfile = {
  dogName: '',
  ageMonths: 4,
  size: 'medium',
  energy: 'medium',
  goals: [],
  problems: [],
  experience: 'first',
  minutesPerDay: 15,
  daysPerWeek: 5,
};
